import React, { useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import Layout, { Container } from "../components/layout";
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';

const UploadAttendance = () => {
  const [file, setFile] = useState(null);
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file || !date) {
      setMessage("Please select a file and date.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("date", date);

    try {
      setLoading(true);
      const res = await axios.post(
        `${apiurl}/api/attendance/upload-attendance`,
        formData
      );
      setMessage(res.data.message || "Upload successful!");
    } catch (err) {
      setMessage(err.response?.data?.message || "Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-6 max-w-xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">
            Upload Attendance
          </h2>
          <a href="/attendance.xlsx" className="text-blue-700">Download Sample File</a>
        </div>

          <form
            onSubmit={handleSubmit}
            className="bg-white p-6 rounded-xl border border-[#98BDFF] shadow space-y-4"
          >
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Date
              </label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                className="w-full border border-gray-300 rounded-lg p-2 focus:ring-[#98BDFF] focus:border-[#98BDFF]"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Upload Excel File
              </label>
              <input
                type="file"
                accept=".xls,.xlsx,.csv"
                onChange={(e) => setFile(e.target.files[0])}
                className="w-full border border-gray-300 rounded-lg p-2 focus:ring-[#98BDFF] focus:border-[#98BDFF]"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="bg-[#7DA0FA] text-white px-4 py-2 rounded-lg hover:bg-[#5f87f1] transition"
            >
              {loading ? "Uploading..." : "Upload"}
            </button>

            {message && (
              <p className="mt-3 text-sm text-gray-700 bg-gray-100 p-2 rounded">
                {message}
              </p>
            )}
          </form>
        </div>
      </Container>
    </Layout>
  );
};

export default UploadAttendance;




